import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { formatPercentage } from '../../utils/functions'
import AsOfDate from '../../components/AsOfDate'

const NoSpacingTable = styled(Table)(({ theme }) => ({
  borderSpacing: 0,
}))

const ItemContainer = styled(TableRow)(({ theme, isOdd }) => ({
  height: '64px',
  width: '330px',
  border: `1px solid ${theme.palette.primary.light}`,
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  padding: '0 12px',
  position: 'relative',
  backgroundColor: isOdd ? theme.palette.primary.light : 'transparent',
  [theme.breakpoints.down('sm')]: {
    width: '90vw',
  },
}))

const RightText = styled(TableCell)(({ theme }) => ({
  marginLeft: 'auto',
  textAlign: 'right',
}))

const AnnualizedReturns = ({ data }) => {
  const fundReturns = get(data, 'performance.fundReturn', {})

  const rowData = [
    {
      title: 'YTD Return',
      data: fundReturns.yearToDate
        ? formatPercentage(fundReturns.yearToDate)
        : '--',
    },
    {
      title: '1 Yr.',
      data: fundReturns.oneYear ? formatPercentage(fundReturns.oneYear) : '--',
    },
    {
      title: '5 Yr.',
      data: fundReturns.fiveYear
        ? formatPercentage(fundReturns.fiveYear)
        : '--',
    },
    {
      title: '10 Yr.',
      data: fundReturns.tenYear ? formatPercentage(fundReturns.tenYear) : '--',
    },
    {
      title: 'Since Inception',
      data: fundReturns.sinceInception
        ? formatPercentage(fundReturns.sinceInception)
        : '--',
    },
  ]

  const asOfDate = get(data, 'performance.calendar.date')

  return (
    <>
      <TableContainer>
        <NoSpacingTable role="presentation">
          <TableBody>
            {rowData.map((row, index) => (
              <ItemContainer key={row.title} isOdd={index % 2 !== 0}>
                <TableCell>
                  <Typography variant="body2" color="textPrimary">
                    {row.title}
                  </Typography>
                </TableCell>
                <RightText>
                  <Typography color="primary" variant="body2">
                    {row.data}
                  </Typography>
                </RightText>
              </ItemContainer>
            ))}
          </TableBody>
        </NoSpacingTable>
      </TableContainer>
      <AsOfDate date={asOfDate} />
    </>
  )
}

AnnualizedReturns.propTypes = {
  data: PropTypes.shape({
    performance: PropTypes.shape({
      fundReturn: PropTypes.shape({
        yearToDate: PropTypes.number,
        oneYear: PropTypes.number,
        fiveYear: PropTypes.number,
        tenYear: PropTypes.number,
        sinceInception: PropTypes.number,
      }),
      calendar: PropTypes.shape({
        date: PropTypes.string,
      }),
    }),
  }).isRequired,
}

export default AnnualizedReturns
